import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import formimg from "../Forms/Performance-Appraisal-Templates-1-1013x439 1.svg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { baseURL } from "../../config";

function CreateJobFamilyForm() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [jobs, setJobs] = useState(null);
  const [options, setOptions] = useState([]);
  const [options2, setOptions2] = useState([]);
  const handleSubmit = async (values) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getalljobfamily`
        );
        setOptions(response.data.jobfamily);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchOptions();
  }, []);

  useEffect(() => {
    const fetchOptions2 = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getalljobroles`
        );
        setOptions2(response.data.jobroles);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchOptions2();
  }, []);

  const handleConfirmSubmit = async () => {};

  return (
    <>
      <Formik initialValues={{}} onSubmit={handleSubmit}>
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <div className="container">
            <h4 className="text-start  pb-2">CREATE JOB FAMILY</h4>
            <div className="col-lg-12  mt-1 m-5">
              <form noValidate onSubmit={handleSubmit}>
                <div className="row">
                  <div class="col-lg-5 ml-2">
                    <label>Job Family</label>
                    <select
                      className="form-select form-control"
                      name='jobfmly"'
                    >
                      {options &&
                        options.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.jobfamily}
                          </option>
                        ))}
                    </select>
                    <div>
                      <div>
                        <a
                          className="btn btn-primary bviolet mt-3 p-2 text-decoration-none mt-4"
                          href="/AddJobFambut"
                        >
                          Add JobFamily +
                        </a>
                      </div>
                    </div>
                  </div>
                  {/* <div class="col-lg-5 ml-2">
                    <label>Training Name</label>
                    <select className='form-select form-control' name='skilllevel' value={values.skilllevel} onChange={handleChange}>
                      <option selected value="Beginner"></option>
                      <option value="Officers-Service Quality">cargo training</option>
                      <option value="Maintenance Supervisor - Civil">DGCA training</option>
                    </select>
                  </div> */}
                  {/* <div className="col-lg-5 mt-2">
                    <label>Justification</label>
                    <textarea
                      className={`form-control ${touched.justification && errors.justification ? 'is-invalid' : ''}`}
                      placeholder="Enter description"
                      name="justification"
                      value={values.justification}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></textarea>
                    {touched.justification && errors.justification ? <div className="text-danger">{errors.justification}</div> : null}
                  </div> */}
                  {/* <div class="col-lg-5  ml-5">
                    <label>Duration</label><br />
                    <input
                      type="time"
                      className='form-control'
                      placeholder="enter duration"
                      min={0}
                      name='progress'
                      onChange={handleChange}
                      value={values.progress}
                    ></input>
                  </div> */}
                  <div class="col-lg-5 ml-5">
                    <label>Job Role</label>
                    <select
                      multiple={true}
                      className="form-select form-control"
                      name="skilllevel"
                      value={values.skilllevel}
                      onChange={handleChange}
                    >
                      {options2 &&
                        options2.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.jobrole}
                          </option>
                        ))}
                    </select>
                    <div>
                      <div>
                        <a
                          className="btn btn-primary bviolet mt-3 p-2 text-decoration-none mt-4"
                          href="/AddJobRolebut"
                        >
                          Add JobRole +
                        </a>
                      </div>
                    </div>
                  </div>
                  {/* <div class="col-lg-5 mt-2">
                    <label>Category</label>
                    <select className='form-select form-control' name='category' value={values.category} onChange={handleChange}>
                      <option selected>Selected Category</option>
                      <option value="Manufacturing">Manufacturing</option>
                      <option value="IT">IT</option>
                      <option value="Skilled Labor">Skilled Labor</option>
                    </select>
                  </div> */}
                </div>
                <div className="col-lg-11 text-end mt-5 pb-3">
                  {/* <!-- Button trigger modal --> */}
                  <button
                    type="button"
                    className="border-0 mt-3 p-1 savebtn fst-normal"
                    data-bs-target="#exampleModal"
                  >
                    Save
                  </button>

                  {/* <!-- Modal --> */}
                  <div
                    class="modal fade"
                    id="exampleModal"
                    tabindex="-1"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5
                            class="text-dark fw-bold h5"
                            id="exampleModalLabel"
                          >
                            CONFIRM CHANGES
                          </h5>
                          <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div class="modal-body">...</div>
                        <div class="modal-footer">
                          <button
                            type="button"
                            class="btn btn-primary subcatbtn"
                          >
                            Save changes
                          </button>
                          <button
                            type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <a
                    href="/combojobfamandrole"
                    className="text-decoration-none "
                  >
                    {" "}
                    <Button
                      type="button"
                      className="btn cancelbtn ml-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                  </a>
                </div>
              </form>
            </div>
          </div>
        )}
      </Formik>

      {/* Confirmation Modal */}
      <div className="col-lg-12">
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Do You Want to Confirm the changes?</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleConfirmSubmit}>
              Yes
            </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              No
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default CreateJobFamilyForm;
